import { Vue, Component, Prop } from 'vue-property-decorator';
import CMCompletionScore from '../competency-completion-score/competency-completion-score';

@Component({
    name: 'default-min-score',
    components: {
        'mastery-completion-score': CMCompletionScore,
    },
})

export default class DefaultMinScore extends Vue {

    // --------------------------------------------------------------------------
    // Properties

    @Prop()
    private selectedConfig: any;

    private defaultMinScore: any = '0';

    @Prop()
    private contentLoader: any;

    @Prop()
    private tenantSettings: any;


    // ---------------------------------------------------------------------------
    // Hooks

    private created() {
        this.defaultMinScore = this.selectedConfig.tenantConfig.value || '0';
    }

    // --------------------------------------------------------------------------
    // Actions

    private onSelectConfig() {
        this.$emit('onChangeConfig', this.defaultMinScore);
    }
}
